<sc-master-detail [selection]="[selectedOption]" [data]="selectDefinition.options"
  (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);"
  (deleteEntry)="onDeleteEntry($event);" [level]="2" class="template-lookup-editor">

  @if (selectedOption) {
    <sc-padding>
      <sc-flex vertical fitHeight stretchContent>
        <div class="value-details no-field-space">
          @if (selectDefinition != null) {
            <ng-container [formGroup]="optionDetailsFormGroup">
              <mat-form-field class="full-size-field" appearance="fill">
                <mat-label>
                  <sc-dictionary-label dictionaryKey="tmc-yard.entity.document-template-select-definition.identifier"></sc-dictionary-label>
                </mat-label>
                <input matInput name="identifier" formControlName="identifier" [required]="true"
                  [maxLength]="255">
                </mat-form-field>
              </ng-container>
            }
          </div>
          <sc-content-spacer vertical></sc-content-spacer>
          <div class="field-value-title">abhängige Feldwerte</div>
          <sc-list-spacer [levelClass]="'level-2'"></sc-list-spacer>
          <div class="field-details" [formGroup]="attributeValueDetailsFormGroup">
            @for (attributeValue of selectedOption?.attributeValues; track attributeValue) {
              <div class="field-entry" (click)="selectAttribute(attributeValue)"
                [ngClass]="{'selected': selectedAttribute === attributeValue}">
                <sc-flex >
                  <div class="field-name">
                    @if (selectedAttribute !== attributeValue) {
                      <span>{{attributeValue.key}}</span>
                    }
                    @if (selectedAttribute === attributeValue) {
                      <mat-form-field class="full-size-field" appearance="fill"
                        >
                        <mat-label>
                          <sc-dictionary-label dictionaryKey="tmc-yard.entity.document-template-select-definition.identifier"></sc-dictionary-label>
                        </mat-label>
                        <input matInput name="key" formControlName="key" [required]="true"
                          [maxLength]="255">
                        </mat-form-field>
                      }
                    </div>
                    <sc-content-spacer></sc-content-spacer>
                    <div class="field-value">
                      @if (selectedAttribute !== attributeValue) {
                        <span>{{attributeValue.value}}</span>
                      }
                      @if (selectedAttribute === attributeValue) {
                        <mat-form-field class="full-size-field" appearance="fill"
                          >
                          <mat-label>
                            <sc-dictionary-label dictionaryKey="tmc-yard.entity.document-template-select-definition.identifier"></sc-dictionary-label>
                          </mat-label>
                          <input matInput name="value" formControlName="value" [required]="true"
                            [maxLength]="255">
                          </mat-form-field>
                        }
                      </div>
                      @if (selectedAttribute === attributeValue) {
                        <sc-content-spacer grow>
                        </sc-content-spacer>
                      }
                      @if (selectedAttribute === attributeValue) {
                        <div class="field-action"><i
                        class="fa-light fa-trash" (click)="deleteAttribute(attributeValue)"></i></div>
                      }
                    </sc-flex>
                  </div>
                  <sc-list-spacer [levelClass]="'level-2'"></sc-list-spacer>
                }
              </div>
              <sc-content-spacer vertical></sc-content-spacer>
              <sc-flex [centered]="true">
                <button mat-stroked-button (click)="addAttribute()">
                  <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
                  add
                </button>
              </sc-flex>
            </sc-flex>
          </sc-padding>
        }

      </sc-master-detail>
